import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { RotateCcw, X } from "lucide-react";
import { getSplashTheme } from "@/lib/splashThemes";
import { SplashStage } from "@/components/media/SplashStage";

/** Plays the real full-screen splash for Rob, with replay and close. */
export const SplashPlayer = ({ themeId, onClose }) => {
  const theme = getSplashTheme(themeId);
  const [run, setRun] = useState(0);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = ""; };
  }, [onClose]);
  return createPortal(
    <div className="fixed inset-0 z-[120]" role="dialog" aria-modal="true" aria-label={`${theme.label} splash`} data-testid="splash-player">
      <SplashStage key={run} theme={theme} testId="splash-player-stage" />
      <div key={`bar-${run}`} className="splash-player-progress" style={{ animationDuration: `${theme.duration}ms` }} data-testid="splash-player-progress" />
      <div className="absolute bottom-[9cqh] left-1/2 z-[121] flex -translate-x-1/2 items-center gap-2 rounded-full border border-white/20 bg-black/40 p-1.5 pl-4 text-white backdrop-blur-md sm:bottom-10">
        <span className="hidden text-xs uppercase tracking-widest text-white/80 sm:inline" data-testid="splash-player-label">{theme.label}</span>
        <button type="button" onClick={() => setRun((n) => n + 1)} data-testid="splash-player-replay"
          className="flex h-9 items-center gap-1.5 rounded-full bg-white px-4 text-sm font-medium text-ink transition-colors hover:bg-neutral-200"><RotateCcw className="h-4 w-4" /> Replay</button>
        <button type="button" onClick={onClose} aria-label="Close preview" data-testid="splash-player-close"
          className="grid h-9 w-9 place-items-center rounded-full border border-white/30 transition-colors hover:bg-white hover:text-ink"><X className="h-4 w-4" /></button>
      </div>
    </div>,
    document.body,
  );
};
